import React from "react";
import "./../../styles/places.css";
import { Container, Row, Col } from "reactstrap";
import tour1 from "./../../assets/images/mountabu.jpg";
import Newsletter from "../../shared/Newsletter";

const MountAbu = () => {
  return (
    <>
      <div className="center-content">
        <h1 className="centered-title text-3xl font-bold mt-6 mb-4">
          MountAbu
        </h1>
        <section>
          <Container>
            <Row>
              <Col lg="12">
                <div className="details__container mx-auto">
                  <div className="mb-4 ">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Destinations Covered:
                    </h2>
                    <ul className="list-disc pl-4">
                      <li>Nakki Lake</li>
                      <li>Achalgarh Fort</li>
                      <li>Dilwara Jain Temple</li>
                    </ul>
                  </div>

                  <h2
                    className="text-xl font-semibold"
                    style={{ textAlign: "left" }}
                  >
                    About MountAbu
                  </h2>
                  <Col lg="6">
                    <div className="wrapingimage">
                      <img src={tour1} alt="" />
                    </div>
                  </Col>
                  <p>
                    Mount Abu- the only hill station of the desert land is the
                    top peak part of Aravali mountain chain in the western
                    India. It is one the most amazing and astonishing tourist
                    destinations of India. Mount Abu is a beautiful tourist
                    destination; reflect the mix culture of Rajasthan's culture
                    and natural resources. This world famous tourist destination
                    is blessed with beautiful natural resources, rivers, lake,
                    lush green forests and outfields, Temples, local culture,
                    forts, palaces, and many more tourist attraction spots.
                  </p>

                  <p>
                    Mount Abu with its world-class hospitality services and
                    accessories provides an unforgettableand fascinating
                    experience for tourists. Every year summer festival and
                    other recreational activities take place there and that is
                    the most beautiful part of it, when different culture come
                    together and makes it anmemorable experience.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Nakki Lake
                  </h2>

                  <p>
                    This is the most popular tourist destination in Mount Abu.
                    The lake forms the "Heart of Mount Abu". Nakki Lake derives
                    its name from the famous mythological story that lies behind
                    the creation of this lake, which says that Gods had dug this
                    lake using their nakh which means nails. This lake is the
                    only artificial lake in India that is situated at an
                    altitude of 1220 meters above sea level.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Achalgarh Fort
                  </h2>
                  <p>
                    The fort was commissioned by RanaKumbha. It is situated at a
                    distance of 8 Kilometers from the town and is well connected
                    by road. The battlement walls surround the Achalgarh fort on
                    all its sides. The fort is situated on top of a mountain
                    peak. Within the walls one will find a number of fortresses
                    and temples.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Dilwara Jain Temple
                  </h2>
                  <p>
                    Mount Abu was an important Vaishnava and Shaivite pilgrim
                    centre up to the 11th century. Today it is recognized all
                    over the world for its magnificent Jain temples. These
                    temples are known for their superb carvings in marble and
                    they were brought all the way from Makrana and the best
                    workmen and craftsmen were employed to ensure the finest
                    quality of sculpture. A trip to Mount Abu is incomplete
                    without a visit to the Dilwara Jain temples. This is at a
                    distance of about 3kms from the town.
                  </p>

                </div>
              </Col>
              <Col lg="4">
                {/* Add a newsletter component or other content in the right column */}
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Newsletter />
    </>
  );
};

export default MountAbu;
